import throttle from 'lodash.throttle'

import { onElementsAvailable } from 'src/utils/onElements'

const READY_ATTR = 'data-horizontal-scroll-ready'

const initHorizontalScroll = scroll => {
  const scrollArea = scroll.querySelector('.horizontal-scroll-area')
  const prevButton = scroll.querySelector('.horizontal-scroll-button[value="-1"]')
  const nextButton = scroll.querySelector('.horizontal-scroll-button[value="1"]')

  if (!prevButton || !nextButton) {
    console.warn('One or both scroll buttons missing in horizontal scroll. Bailing')
    return
  }

  // onElementsAvailable can deliver the same element more than once --
  // appending a container and then populating it yields two records in
  // one batch that both resolve to this node. Everything below is a
  // fresh function identity, so addEventListener's dedup-by-reference
  // never engages: a re-run stacks a second ResizeObserver that nothing
  // disconnects.
  //
  // The check sits below the bail above, and the marker is set at the
  // very end of the function, so any early return or throw leaves the
  // element retryable rather than marked-but-unwired. scrollArea is not
  // null-checked, so that throw is reachable in principle.
  //
  // End-placement trades "marked but unwired" for "unmarked but partly
  // wired", and that trade is only free because the sole reachable throw
  // (scrollArea) precedes every addEventListener and ResizeObserver call
  // below -- a retry starts clean. Introduce a fallible statement after
  // the wiring begins and a retry would re-stack the listeners this
  // marker exists to prevent.
  //
  // Safe against same-batch double-delivery either way: handleMutations
  // invokes the callback sequentially, so the first call sets the marker
  // before the second reads it -- there is no interleaving window.
  if (scroll.hasAttribute(READY_ATTR)) return

  const handleScroll = () => {
    prevButton.disabled = !scrollArea.scrollLeft
    nextButton.disabled = Math.round(scrollArea.offsetWidth + scrollArea.scrollLeft) >= scrollArea.scrollWidth
  }

  scrollArea.addEventListener('scroll', throttle(handleScroll, 66))
  handleScroll()

  const resizeObserver = new ResizeObserver(handleScroll)
  resizeObserver.observe(scrollArea)

  const handleButtonClick = e =>
    scrollArea.scrollBy({
      left: scroll.offsetWidth * e.currentTarget.value,
      behavior: 'smooth',
    })

  prevButton.addEventListener('click', handleButtonClick)
  nextButton.addEventListener('click', handleButtonClick)

  scroll.setAttribute(READY_ATTR, '')
}

const init = () =>
  onElementsAvailable('.horizontal-scroll', initHorizontalScroll)

document.addEventListener('DOMContentLoaded', init)
